import { render, staticRenderFns } from "./MultiheaderTable.vue?vue&type=template&id=63bf038a&scoped=true&"
import script from "./MultiheaderTable.vue?vue&type=script&lang=js&"
export * from "./MultiheaderTable.vue?vue&type=script&lang=js&"
import style0 from "./MultiheaderTable.vue?vue&type=style&index=0&id=63bf038a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf038a",
  null
  
)

export default component.exports